import React, { FunctionComponent } from 'react';

// components
import { PriceAmount } from './PriceAmount';

type Props = {
    price?: number;
    currency: string;
    quantityDisplay: string | null;
    showPriceLabel: boolean;
    hasPrivateOffer?: boolean;
};

/**
 * Price Components for an item with just a retail price
 */
export const RetailItemPrices: FunctionComponent<Props> = ({
    price,
    currency,
    quantityDisplay,
    showPriceLabel,
    hasPrivateOffer,
}) => (
    /* RETAIL PRICE */
    <PriceAmount
        currency={currency}
        amount={price}
        showLabel={showPriceLabel}
        quantityDisplay={quantityDisplay}
        hasPrivateOffer={hasPrivateOffer}
    />
);
